import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { formatTime, inputTimeToDecimal } from '../../shared/time';
import { AlertService } from '../../core/alerts/alert.service';
import { ConfirmService } from '../../shared/confirm-dialog/confirm-dialog.service';

@Component({
    selector: 'app-medarbejdere-hour-input',
    templateUrl: './medarbejdere-hour-input.component.html',
    styleUrls: ['./medarbejdere-hour-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class MedarbejdereHourInputComponent {
    @Input() id: number;
    @Input() compact = false;
    @Input() label = 'Normtid';
    @Input() timer: number;
    @Input() kode = 0;
    @Input() disabled = false;
    @Input() dayTotal: number;
    @Output() saveTimer = new EventEmitter<{timer: number}>();
    @ViewChild('hourInput') timerInput: ElementRef;

    constructor(
        private alert: AlertService,
        private confirm: ConfirmService
    ) {}

    focus() {
        if (!this.disabled) { this.timerInput.nativeElement.focus(); }
    }

    onChangeTimer(newValue: string) {
        if (!newValue && !this.timer) {
            if (this.compact) { this.timerInput.nativeElement.value = this.timer == null ? '' : formatTime(this.timer); }
            return;
        }
        const convertedValue = inputTimeToDecimal(newValue);
        if (isNaN(+convertedValue)) {
            this.alert.createAlert('Der er fejl i den indtastede værdi', 'danger');
            this.timerInput.nativeElement.focus();
            this.timerInput.nativeElement.select();
            return;
        }
        if (+convertedValue === this.timer) {
            this.timerInput.nativeElement.value = formatTime(this.timer);
            return;
        }
        if (this.dayTotal + +convertedValue - this.timer > 24) {
            this.confirm
                .question('Du har indtastet mere end 24 timer på én dag. Er dette korrekt?', 'Ja', 'Nej')
                .then(result => {
                    !result
                        ? this.timerInput.nativeElement.value = formatTime(this.timer)
                        : this.emitSaveTimer(+convertedValue);
                });
        } else if (this.dayTotal + +convertedValue - this.timer < 0) {
            this.confirm
                .question('Denne indtastning vil give et negativt timeantal på dagen. Er dette korrekt?', 'Ja', 'Nej')
                .then(result => {
                    !result
                        ? this.timerInput.nativeElement.value = formatTime(this.timer)
                        : this.emitSaveTimer(+convertedValue);
                });
        } else {
            this.emitSaveTimer(+convertedValue);
        }
    }

    getColorClass(): string {
        switch (this.kode) {
            case 1: return 'hour-input--ferie';
            case 2: return 'hour-input--barsel';
            case 3: return 'hour-input--skole';
            case 4: return 'hour-input--afspadsering';
            default: return '';
        }
    }

    emitSaveTimer(timer: number) {
        // Keep the persisted value visible until the compact calendar receives the server response.
        // On failure the field therefore cannot present an unsaved value as saved.
        if (this.compact) {
            this.timerInput.nativeElement.value = this.timer == null ? '' : formatTime(this.timer);
        }
        this.saveTimer.emit({timer});
    }
}
